/**
 * DragOverlay modifier: pin the chip's top-left near the pointer
 * (matches Test Groups HTML5 setDragImage(preview, 0, 0) feel).
 */
export function snapTopLeftToCursor({ activatorEvent, draggingNodeRect, transform }) {
  if (!draggingNodeRect || !activatorEvent || !('clientX' in activatorEvent)) {
    return transform;
  }

  const offsetX = activatorEvent.clientX - draggingNodeRect.left;
  const offsetY = activatorEvent.clientY - draggingNodeRect.top;

  return {
    ...transform,
    x: transform.x + offsetX,
    y: transform.y + offsetY,
  };
}
